import { createContext, useContext } from 'react';
import { useQuote } from '../hooks/useQuote';
import type { OrgInventoryItem } from '../types/admin';

export interface QuoteContextValue extends ReturnType<typeof useQuote> {
  /**
   * Org inventory, fetched once by the shell and shared with every sub-page
   * (item pickers, materials, breakdown, formula engine). Sub-pages must read
   * it from here rather than calling useOrgInventory themselves.
   */
  orgItems: OrgInventoryItem[];
  orgItemsLoading: boolean;
  /** Set when the inventory request failed (e.g. permissions or timeout). */
  orgItemsError: string | null;
}

const QuoteContext = createContext<QuoteContextValue | null>(null);

export const QuoteContextProvider = QuoteContext.Provider;

/**
 * Access the shared quote state provided by QuoteShell.
 * All quote sub-pages should use this instead of calling useQuote directly.
 */
export function useSharedQuote() {
  const ctx = useContext(QuoteContext);
  if (!ctx) throw new Error('useSharedQuote must be used within QuoteShell');
  return ctx;
}
